import { Component, OnInit , ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GetPromptService } from '../../services/get-prompts/get-prompts.service';
import { CadastroPromptService } from '../../services/cadastro-prompt/cadastro-prompt.service';
import { MessageNotificationService } from '../../services/message-notification.service';
import { AuthService } from '../../services/auth.service';
import { VALIDATION_MESSAGES, SUCCESS_MESSAGES, ERROR_MESSAGES } from '../../constants/validation-messages';
import { handleHttpError } from '../../utils/error-handler.util';
import { sanitizeTag, addTagUnique, isValidTag } from '../../utils/tag-utils';
import { CategoriaPai } from '../../constants/categoria-pai';
import { PromptDto } from '../../models/prompt-dto.model';
import { Categoria } from '../../models/categoria.model';
import {
  categoriaFilhaDoPaiFinalidade,
  resolveIdCategoriaPaiFinalidade,
} from '../../utils/categoria-finalidade.util';

@Component({
    selector: 'editar-prompt',
    templateUrl: './editar-prompt.component.html',
    styleUrls: ['./editar-prompt.component.css'],
    standalone: false
})
export class EditarPromptComponent implements OnInit {
  text: string | undefined;

  edicao: FormGroup;
  MAX_RESUMO: number = 500;
  MAX_PROMPT: number = 12000;
  tags: string[] = [];
  promptId: number | null = null;
  isChecked = false;
  termo = false;
  categorias: any[] = [];
  filtrarCategorias: any[] = this.categorias;
  selecionarCategorias: any[] = [];
  selecionarIdCategorias: number[] = [];
  filtrarCategoriasProcess: any[] = this.categorias;
  filtrarCategoriasIns: any[] = this.categorias;
  filtrarCategoriasJus: any[] = this.categorias;
  filtrarCategoriasAreaDir: any[] = this.categorias;
  selecionarCaracFinalidade: any[] = [];
  dropdownCategoria: boolean = false;
  idPaiFinalidade: number | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private getPromptService: GetPromptService,
    private cadastroPromptService: CadastroPromptService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private messageNotificationService: MessageNotificationService,
    private authService: AuthService
  ) {
    this.edicao = this.fb.group({
      titulo: [''],
      instrucoes: [''],
      resumo: [''],
      prompt: [''],
      anonimo: [false],
      termo: [false],
      pesquisaCategoria: [''],
    });
  }

  ngOnInit() {
    this.cadastroPromptService.categoriaPrompt().subscribe({
      next: (res) => {
        this.categorias = res.data;
        this.idPaiFinalidade = resolveIdCategoriaPaiFinalidade(this.categorias);
        if (this.idPaiFinalidade === null) {
          this.messageNotificationService.showError(
            'Categoria pai "Finalidade" não encontrada na base.'
          );
        }
        this.aplicarFiltrosFinalidade();
        this.filtrarCategoriasCarFid(this.categorias);

        this.promptId = Number(this.route.snapshot.paramMap.get('id'));
        if (this.promptId) {
          this.carregarDadosPrompt(this.promptId);
        } else {
          this.messageNotificationService.showError(
            ERROR_MESSAGES.NOT_FOUND,
            'ID não fornecido'
          );
          this.router.navigate(['/painel']);
        }
      },
      error: (err) => {
        this.messageNotificationService.showError(
          'Erro ao consultar categorias do prompt.'
        );
        console.error('Erro ao consultar categorias do prompt:', err);
      },
    });
  }

  private aplicarFiltrosFinalidade(): void {
    if (this.idPaiFinalidade === null) {
      this.filtrarCategorias = [];
      this.filtrarCategoriasOrdenadas = [];
      return;
    }
    this.filtrarCategorias = this.categorias.filter(
      (x) =>
        categoriaFilhaDoPaiFinalidade(x, this.idPaiFinalidade) &&
        x.status == 'A'
    );
    this.filtrarCategoriasOrdenadas = [...this.filtrarCategorias].sort((a, b) =>
      (a.categoria_descricao || '').localeCompare(b.categoria_descricao || '')
    );
  }

filtrarCategoriasCarFid(categorias: any[]) {
  this.filtrarCategoriasProcess = this.categorias.filter((x) => x.categoria_pai == CategoriaPai.TipoDeProcesso && x.status == "A");
  this.filtrarCategoriasAreaDir = this.categorias.filter((x) => x.categoria_pai == CategoriaPai.AreaDeDireito && x.status == "A");
  this.filtrarCategoriasJus = this.categorias.filter((x) => x.categoria_pai == CategoriaPai.Justica && x.status == "A");
  this.filtrarCategoriasIns = this.categorias.filter((x) => x.categoria_pai == CategoriaPai.Instancia && x.status == "A");

  const ordenar = (a: any, b: any) => (a.categoria_descricao || '').localeCompare(b.categoria_descricao || '');

  this.filtrarCategoriasProcessOrdenadas = [...this.filtrarCategoriasProcess].sort(ordenar);
  this.filtrarCategoriasAreaDirOrdenadas = [...this.filtrarCategoriasAreaDir].sort(ordenar);
  this.filtrarCategoriasJusOrdenadas = [...this.filtrarCategoriasJus].sort(ordenar);
  this.filtrarCategoriasInsOrdenadas = [...this.filtrarCategoriasIns].sort(ordenar);
}

filtrarCategoria(): void {
  const termoBusca = this.edicao.get('pesquisaCategoria')?.value.toLowerCase();

  const listaCompletaFinalidades = this.categorias
      .filter(
        (x) =>
          categoriaFilhaDoPaiFinalidade(x, this.idPaiFinalidade) &&
          x.status == 'A'
      )
      .sort((a, b) =>
        (a.categoria_descricao || '').localeCompare(b.categoria_descricao || '')
      );

  this.filtrarCategorias = listaCompletaFinalidades;

  if (termoBusca) {
    this.filtrarCategoriasOrdenadas = listaCompletaFinalidades.filter(categoria =>
      categoria.categoria_descricao.toLowerCase().includes(termoBusca)
    );
  } else {
    this.filtrarCategoriasOrdenadas = listaCompletaFinalidades;
  }
}

  filtrarCategoriasOrdenadas: any[] = [];
  filtrarCategoriasProcessOrdenadas: any[] = [];
  filtrarCategoriasInsOrdenadas: any[] = [];
  filtrarCategoriasJusOrdenadas: any[] = [];
  filtrarCategoriasAreaDirOrdenadas: any[] = [];

  carregarDadosPrompt(id: number) {
    this.getPromptService.getPromptById(id).subscribe({
      next: (res) => {
        const promptArray = res.data;

        if (!promptArray || promptArray.length === 0) {
          this.messageNotificationService.showError(
            ERROR_MESSAGES.NOT_FOUND,
            'Dados não encontrados'
          );
          this.router.navigate(['/painel']);
          return;
        }

        const prompt = promptArray[0];
        this.edicao.patchValue({
          titulo: prompt.prompt_titulo || '',
          instrucoes: prompt.prompt_instrucoes || '',
          resumo: prompt.prompt_descricao || '',
          prompt: prompt.prompt_comando || '',
          anonimo: prompt.prompt_anonimo || '',

        });

        prompt.prompt_categoria?.forEach((item: Categoria) => {
          if (categoriaFilhaDoPaiFinalidade(item, this.idPaiFinalidade)) {
            this.selecionarCategorias.push(item);
          } else {
            this.selecionarCaracFinalidade.push(item);
          }
        });

        if (Array.isArray(prompt.prompt_tags)) {
          this.tags = prompt.prompt_tags.map((tag: any) => tag.tag_nome);
        } else {
          this.tags = [];
        }
      },
      error: (err) => {
        console.error('Erro ao carregar prompt:', err);
        const errorMessage = handleHttpError(err);
        this.messageNotificationService.showError(
          'Não foi possível carregar o prompt. ' + errorMessage
        );
        this.router.navigate(['/painel']);
      },
    });
  }

  qtdCaracteres(campo: string): number {
    const valor = this.edicao.get(campo)?.value;
    return valor ? valor.length : 0;
  }

  onTagInput(event: KeyboardEvent): void {
  const input = event.target as HTMLInputElement;
  const isComma = event.key === ',';
  const isEnter = event.key === 'Enter';

  if (isComma || isEnter) {
    event.preventDefault();
    const rawTag = input.value.trim();
    if (rawTag) {
      const sanitizedTag = sanitizeTag(rawTag);
      if (/^_+$/.test(sanitizedTag)) {
        this.messageNotificationService.showError(
          VALIDATION_MESSAGES.INVALID_TAG,
          'Palavra-chave inválida'
        );
        return;
      }
      if (isValidTag(sanitizedTag)) {
        this.tags = addTagUnique(sanitizedTag, this.tags);
      } else {
        this.messageNotificationService.showError(
          VALIDATION_MESSAGES.INVALID_TAG_KEYWORD,
          'Palavra-chave inválida'
        );
        return;
      }
    }
    input.value = '';
  }
}

  onPaste(event: ClipboardEvent): void {
  const { clipboardData } = event;
  const temp = clipboardData?.getData('text');
  event.preventDefault();
  if (!temp) return;
  const partes = temp.split(',').map((p) => p.trim()).filter((p) => p);
  partes.forEach((parte) => {
    const sanitizedTag = sanitizeTag(parte);
    if (isValidTag(sanitizedTag)) {
      this.tags = addTagUnique(sanitizedTag, this.tags);
    }
  });
  (event.target as HTMLInputElement).value = '';
  }

  removeTag(tag: string): void {
    this.tags = this.tags.filter((t) => t !== tag);
  }

  toggleCheckbox(value : boolean): void {
    this.isChecked= value;
  }

  toggleCheckboxTermo(value : boolean): void {
    this.termo= value;
  }

  atualizarPrompt() {
    if (!this.promptId) {
      this.messageNotificationService.showError(
        ERROR_MESSAGES.NOT_FOUND,
        'ID do prompt não encontrado'
      );
      return;
    }

    const userData = this.authService.getUserData();
    const usuario_id = userData?.usuario_id;

    if (!userData || !usuario_id) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.LOGIN_REQUIRED
      );
      return;
    }

    if (!this.validarCamposObrigatorios()) {
      return;
    }

    this.selecionarIdCategorias = Array.from(
      new Set([
        ...this.selecionarCategorias.map(cat => cat.categoria_id),
        ...this.selecionarCaracFinalidade.map(cat => cat.categoria_id)
      ])
    );

    const promptData = {
      prompt_id: this.promptId,
      prompt_titulo: this.edicao.get('titulo')?.value,
      prompt_descricao: this.edicao.get('resumo')?.value,
      prompt_comando: this.edicao.get('prompt')?.value,
      prompt_tags: this.tags,
      prompt_anonimo: this.edicao.get('anonimo')?.value,
      prompt_instrucoes: this.edicao.get('instrucoes')?.value,
      prompt_pai: 0,
      prompt_categoria: this.selecionarIdCategorias,
    };

    this.cadastroPromptService.atualizarPrompt(promptData).subscribe({
      next: (res) => {
        this.messageNotificationService.showSuccess(
          SUCCESS_MESSAGES.PROMPT_UPDATED
        );
        this.router.navigate(['/painel']);
      },
      error: (err) => {
        console.error('Erro ao atualizar o prompt:', err);
        const errorMessage = handleHttpError(err);
        this.messageNotificationService.showError(errorMessage);
      },
    });
  }

  validarCamposObrigatorios(): boolean {
    if (this.edicao.get('titulo')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.TITLE_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.edicao.get('resumo')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.SUMMARY_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.edicao.get('prompt')?.value == "") {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.PROMPT_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.selecionarCaracFinalidade.length == 0) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.CATEGORIES_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.selecionarCategorias.length == 0) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.FINALITY_REQUIRED,
        'Campo obrigatório'
      );
      return false;
    }

    if (this.termo === false) {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.TERMS_REQUIRED,
        'Aceite os termos'
      );
      return false;
    }

    return true;
  }

  alterarSelecaoCaractFinalidade(categoria: any): void {
    const index = this.selecionarCaracFinalidade.findIndex(
      (item) => item.categoria_id === categoria.categoria_id
    );

    if (index !== -1) {
      this.selecionarCaracFinalidade.splice(index, 1);
    } else {
      this.selecionarCaracFinalidade.push(categoria);
    }
  }

  alterarSelecao(categoria: any): void {
    const index = this.selecionarCategorias.findIndex(
      (item) => item.categoria_id === categoria.categoria_id
    );

    if (index !== -1) {
      this.selecionarCategorias.splice(index, 1);
    } else {
      this.selecionarCategorias.push(categoria);
    }
  }

  selecionado(categoria: any): boolean {
    return this.selecionarCategorias.some(
      (item) => item.categoria_id === categoria.categoria_id
    );
  }

  selecionadoCaractFinalidade(categoria: any): boolean {

    return this.selecionarCaracFinalidade.some(
      (item) => item.categoria_id === categoria.categoria_id

    );
  }


  alterarDropdown(): void {
    this.dropdownCategoria = !this.dropdownCategoria;
    if (this.dropdownCategoria) {
      this.filtrarCategoria();
    }
  }

  get descricaoCategoriasSelecionadas(): string {

    return this.selecionarCategorias.map(cat => cat.categoria_descricao).join(', ');

  }
}
